module.exports = __webpack_public_path__ + "static/media/mov1.56d096ab.mp4";